import { apiClient } from '../../../app/api/apiClient';
import type { AuditEvent, SecurityOverview, SecurityRole, SecuritySession } from '../types/security.types';

export async function getSecurityOverview(): Promise<SecurityOverview> {
  const response = await apiClient.get('/api/super-admin/security/overview');
  return (response.data as { overview: SecurityOverview }).overview;
}

export async function getSecuritySessions(): Promise<SecuritySession[]> {
  const response = await apiClient.get('/api/super-admin/security/sessions');
  return (response.data as { sessions: SecuritySession[] }).sessions;
}

export async function getAuditEvents(limit = 50, offset = 0): Promise<AuditEvent[]> {
  const response = await apiClient.get('/api/super-admin/audit/events', { query: { limit, offset } });
  return (response.data as { events: AuditEvent[] }).events;
}

export async function getSecurityRoles(): Promise<SecurityRole[]> {
  const response = await apiClient.get('/api/super-admin/security/roles');
  const roles = (response.data as { roles: SecurityRole[] }).roles;
  return roles.map((role) => ({
    ...role,
    permission_details: role.permission_details.map((permission) => ({
      ...permission,
      source: permission.source ?? (
        permission.scope === 'system' ? 'system_role_permissions' : 'role_permissions'
      ),
      description: permission.description ?? permission.name,
    })),
  }));
}
